import { Box, Link, Typography } from '@mui/material';
import { FC } from 'react';

export const Step3HMRC: FC = () => {
	return (
		<Box
			sx={{
				display: 'flex',
				flexDirection: 'row',
				mt: '20px',
				gap: '40px',
			}}
		>
			<Box
				sx={{
					display: 'flex',
					backgroundColor: '#0092de24',
					borderRadius: '12px',
					p: '20px',
					// mt: '20px',
					width: 'calc(100%)',
				}}
			>
				<Typography
					sx={{
						fontSize: '3rem',
						color: '#016193',
						fontFamily: 'monospace',
						mr: 2,
						mt: -1,
						mb: -2,
						fontWeight: 'bold',
						textTransform: 'lowercase',
					}}
				>
					i
				</Typography>
				<Box>
					<Typography
						component="p"
						sx={{ fontSize: '1rem', fontStyle: 'italic', color: '#016193', p: '0 0 8px 0' }}
					>
						At the next step you will see a pop-up window leading you to the HMRC Making tax digital
						registration page. Accept all cookies, scroll down to the button &quot;Continue&quot;
						and proceed with sign up. Please, ensure that you have access to the HMRC Government
						gateway, for that you will need your HMRC Gateway ID, password and two factor
						authentication device (your phone that is able to receive messages or use the
						authentication app).
					</Typography>
				</Box>
			</Box>
		</Box>
	);
};
